const RequestStatusesEnum = {
    AWAITING: 'Awaiting',
    APPROVED: "Approved",
    REJECTED: 'Rejected',
    CANCELED: "Canceled",
    EXPIRED: "Expired",
    RETURNED: "Returned"
}
export default RequestStatusesEnum;
